import { computed } from 'vue'

import { useIntervalFn } from '@vueuse/core'

import { badgeCount, badgeText, useMyWorkService } from '@/services/my-work'

/** How often the side nav asks for the badge's counts while ADX is open. */
export const BADGE_POLL_MS = 2 * 60 * 1000

/**
 * The side nav's My work badge: PRs ready to merge plus decisions waiting on me, from the fleet's
 * cached page. A fleet without the counts route, or one that cannot be reached, shows no badge.
 */
export function useMyWorkBadge() {
  const isConfigured = Boolean(import.meta.env.VITE_FLEET_API_BASE_URL)
  const { useMyWorkCounts } = useMyWorkService()
  const { data: counts, refetch } = useMyWorkCounts({ enabled: isConfigured })

  useIntervalFn(() => {
    if (isConfigured) void refetch()
  }, BADGE_POLL_MS)

  const count = computed(() => badgeCount(counts.value))
  const text = computed(() => badgeText(count.value))

  return { count, text }
}
